export { EventAlertDetail } from './EventAlertDetail';
